import eventCategories from '@/constant/eventCategories'
import { YEAR_RECAP_PUBLIC_ROUTE_NAME } from '@/components-v2/year-recap/constants'

export const DISALLOWED_ROUTES_FOR_SKOLETUBE = [
  'Team',
  'UserProfile',
  'UserPlan',
  'Upgrade',
  'BillingList',
  'BillingDetail',
  'WhiteLabel',
]

export const ROUTE_NAMES = {
  HOME: 'Home',
  TRASH_BIN: 'TrashBin',
  MSTEAMS_TABCONFIG: 'MSTeams-TabConfig',
  MSTEAMS_PRESENTING: 'MSTeams-Presenting',
  ZOOM_APP: 'ZoomApp',
  ZOOM_PRESENTATION_LIST: 'ZoomPresentationList',
  ZOOM_AUDIENCE_APP: 'ZoomAudienceApp',
  PRESENTATIONS: 'Presentations',
  PPT_ADDIN_LANDING: 'PptAddinLanding',
  // AHA-47221: the add-in's editor entrance — see business-logic/ppt-addin-editor-routes.
  PPT_ADDIN_EDIT_SLIDES: 'PptAddinEditSlides',
  SHARED_WITH_ME: 'SharedWithMe',
  FOLDER_DETAIL: 'FolderDetail',
  SHARE_FOLDER_DETAIL: 'ShareFolderDetail',
  TEAM_FOLDER_DETAIL: 'TeamFolderDetail',
  TEMPLATE_LIBRARY: 'TemplateLibrary',
  TEMPLATE_CATEGORY: 'TemplateCategory',
  TEAM: 'Team',
  TEAM_MEMBER: 'TeamMember',
  USER_PROFILE: 'UserProfile',
  // AHA-47349-presenter-can-create-new-slide-type
  DEVELOPER: 'Developer',
  SLIDE_TYPE_SHARE: 'SlideTypeShare',
  BILLING_LIST: 'BillingList',
  BILLING_DETAIL: 'BillingDetail',
  COMMUNITY: 'Community',
  CREATE_BLANK: 'CreateBlank',
  CREATE_FROM_AI: 'CreateFromAI',
  CREATE_FROM_TEMPLATE: 'CreateFromTemplate',
  CLAIM_TEMPLATE_PACK: 'ClaimTemplatePack',
  UPGRADE: 'Upgrade',
  UPGRADE_BULK_SUCCESS: 'UpgradeBulkSuccess',
  UPGRADE_SUCCESS: 'UpgradeSuccess',
  STRIPE_TRANSITION: 'StripeTransition',
  USER_PLAN: 'UserPlan',
  REDEEM: 'Redeem',
  PRESENTATION_REPORT: 'PresentationReport',
  SHARED_REPORT: 'SharedReport',
  MARKETPLACE: 'Marketplace',
  MARKETPLACE_DETAIL: 'MarketplaceDetail',
  INTEGRATION_CONNECT: 'IntegrationConnect',
  EMBED_APP: 'EmbedApp',
  WHITE_LABEL: 'WhiteLabel',
  REFERRAL: 'Referral',
  DEMO_PRESENTATION: 'DemoPresentation',
  SSO: 'SSO',
  ONBOARDING_WELCOME: 'OnboardingWelcome',
  AUTH: 'Auth',
  GOOGLE_ONE_TAP_LANDING: 'GoogleOneTapLanding',
  MICROSOFT_AUTH: 'MicrosoftAuth',
  LOGIN: 'Login',
  OAUTH: 'OAuth',
  DEVICE_GRANT: 'DeviceGrant',
  REGISTER: 'Register',
  FORGOT_PASSWORD: 'ForgotPassword',
  VERIFY_EMAIL: 'VerifyEmail',
  TOKEN: 'Token',
  ERROR_404: 'Error404',
  SERVICE_UNAVAILABLE: 'ServiceUnavailable',
  CLEAR_TOKEN: 'ClearToken',
  REPORT_SESSION: 'SessionsReport',
  REPORT_QUESTION: 'QuestionsReport',
  REPORT_SLIDES: 'SlidesReport',
  REPORT_SURVEYS: 'SurveysReport',
  REPORT_SUMMARY: 'SummaryReport',
  REPORT_OVERVIEW: 'OverviewReport',
  REPORT_INSIGHT: 'InsightReport',
  ALL_PARTICIPANTS: 'AllParticipants',
  ALL_PARTICIPANT_RESPONSES: 'AllParticipantResponses',
  PRESENTATION_DETAIL: 'PresentationDetail',
  PRESENTATION_DETAIL_PUBLIC: 'PresentationDetailPublic',
  PRESENTATION_JOIN_VIA_TOKEN: 'JoinPresentationViaToken',
  PRESENTATION_BACKSTAGE: 'PresentationBackstage',
  PRESENTATION_AUDIENCE_TEST: 'PresentationAudienceTest',
  PRESENTATION_SHARE: 'PresentationShare',
  PRESENTATION_SHARE_PRESENT: 'PresentationSharePresent',
  TEMPLATE_VIEW: 'TemplateView',
  TEMPLATE_PREVIEW: 'TemplatePreview',
  PRESENTATION_PLAY_DEMO: 'PresentationPlayDemo',
  SAVE_PRESENTATION: 'SavePresentation',
  GOOGLE_REDIRECT: 'googleRedirect',
  GOOGLE_AUTH: 'googleAuth',
  PRESENTATION_DETAIL_GOOGLE_SLIDE: 'PresentationDetailGoogleSlide',
  PRESENTATION_ERROR_GOOGLE_SLIDE: 'PresentationErrorGoogleSlide',
  GOOGLE_DRIVE_SHORTCUT: 'GoogleDriveShortcut',
  INQUIRIES_FORM: 'InquiriesForm',
  ZOHO_AUTH: 'ZohoAuth',
  CONFIRM_OPENAI: 'ConfirmOpenAI',
  ADMIN_ANALYTICS: 'AdminAnalytics',
  TEAM_SETTINGS: 'TeamSettings',
  DIRECT_BULK_PURCHASE: 'BulkPurchaseRedirect',
  PRESENTING_EXPERIENCE_SURVEY: 'PresentingExperienceSurvey',
  EMBED_SELECT_PRESENTATION: 'EmbedSelectPresentation',
  EMBED_AUTH: 'EmbedAuth',
  EMBED_MY_PRESENTATIONS: 'EmbedMyPresentations',
  EMBED_FOLDER_DETAILS: 'EmbedFolderDetails',
  EMBED_SHARED_WITH_ME: 'EmbedSharedWithMe',
  EMBED_SHARE_FOLDER_DETAILS: 'EmbedShareFolderDetails',
  REFERRAL_EXISTING_USER: 'ReferralExistingUser',
  REFERRAL_INVALID_LINK: 'ReferralInvalidLink',
}

export const NO_CHAT_ROUTES = [
  '2022WrapUp',
  'PresentationShare',
  ROUTE_NAMES.PRESENTATION_SHARE_PRESENT,
  'PresentationPlayDemo',
  'PresentationBackstage',
  'TemplateView',
  ROUTE_NAMES.PRESENTATION_DETAIL_PUBLIC,
  ROUTE_NAMES.EMBED_SELECT_PRESENTATION,
  ROUTE_NAMES.EMBED_MY_PRESENTATIONS,
  ROUTE_NAMES.EMBED_FOLDER_DETAILS,
  ROUTE_NAMES.EMBED_SHARED_WITH_ME,
  ROUTE_NAMES.EMBED_SHARE_FOLDER_DETAILS,
  ROUTE_NAMES.EMBED_AUTH,
  ROUTE_NAMES.PRESENTATION_AUDIENCE_TEST,
]

export const EXCLUDED_SHOWING_TOASTS_ROUTES = [
  ROUTE_NAMES.PRESENTATION_SHARE,
  ROUTE_NAMES.PRESENTATION_SHARE_PRESENT,
]

export const PUBLIC_ROUTES = [
  'Login',
  'OAuth',
  'Token',
  'Register',
  'ForgotPassword',
  ROUTE_NAMES.VERIFY_EMAIL,
  'PresentationShare',
  ROUTE_NAMES.PRESENTATION_SHARE_PRESENT,
  'DemoPresentation',
  'Auth',
  // Like Auth: a guest who just converted through One Tap still holds the guest cookie,
  // and the guest guard would bounce them to register before the page could clear it.
  ROUTE_NAMES.GOOGLE_ONE_TAP_LANDING,
  'SSO',
  'PresentationPlayDemo',
  'SavePresentation',
  'MSTeams-TabConfig',
  'MSTeams-Auth',
  'MSTeams-Presenting',
  'ZoomApp',
  'ZoomAudienceApp',
  'googleRedirect',
  'googleAuth',
  ROUTE_NAMES.MICROSOFT_AUTH,
  'ClearToken',
  'GoogleDriveShortcut',
  'TemplateView',
  'JoinPresentationViaToken',
  ROUTE_NAMES.SHARED_REPORT,
  ROUTE_NAMES.EMBED_AUTH,
  ROUTE_NAMES.EMBED_MY_PRESENTATIONS,
  ROUTE_NAMES.EMBED_FOLDER_DETAILS,
  ROUTE_NAMES.EMBED_SHARED_WITH_ME,
  ROUTE_NAMES.EMBED_SHARE_FOLDER_DETAILS,
  ROUTE_NAMES.PRESENTATION_DETAIL_PUBLIC,
  ROUTE_NAMES.REFERRAL_EXISTING_USER,
  ROUTE_NAMES.REFERRAL_INVALID_LINK,
  ROUTE_NAMES.SERVICE_UNAVAILABLE,
  YEAR_RECAP_PUBLIC_ROUTE_NAME,
]

// AHA-47221: the routes that render the embed presentation list — the My-presentations pair and
// the Shared-with-me pair, all four the same component reading the list its route names.
//
// They stay in PUBLIC_ROUTES above, because the host-embedded (MS Teams) side panel is a public
// surface that signs in through EMBED_AUTH. The PowerPoint add-in reuses the SAME routes as its
// own presentation list, and there "public" is wrong: a signed-out add-in frame would render an
// empty list with no prompt and no way out. The route this list replaced for the add-in
// (Presentations) was never public, so the sign-in used to come for free — this names them so the
// add-in term in router.js's public-route check can take it back.
export const EMBED_PRESENTATION_LIST_ROUTES = [
  ROUTE_NAMES.EMBED_MY_PRESENTATIONS,
  ROUTE_NAMES.EMBED_FOLDER_DETAILS,
  ROUTE_NAMES.EMBED_SHARED_WITH_ME,
  ROUTE_NAMES.EMBED_SHARE_FOLDER_DETAILS,
]

export const SURVEY_ROUTES_NAME = [
  ROUTE_NAMES.PRESENTING_EXPERIENCE_SURVEY,
]

export const OPEN_ROUTES_FOR_GUEST = [...PUBLIC_ROUTES, 'PresentationDetail']

// AHA-46714: a "destination" is a real page the user browses from and can be
// returned to when leaving the editor, marked per route via meta.isDestination
// in router.js; this predicate is the single reader. Unmarked routes
// (create-* interstitials, onboarding, auth pages) are invisible to the
// editor Back button by default — there is no deny-list to keep updated.
// The typeof guard is cheap defense; no route declares meta as a function.
export const isDestinationRoute = (route) => {
  const { meta } = route || {}
  if (!meta || typeof meta === 'function') return false
  return Boolean(meta.isDestination)
}

// I used Chatgpt for this, so please verify the key and value before using it.
// Make changes if needed.
export const EVENT_CATEGORIES_BY_ROUTE_NAME = {
  [ROUTE_NAMES.HOME]: eventCategories.HOME,
  [ROUTE_NAMES.MSTEAMS_TABCONFIG]: eventCategories.MS_TEAMS_APP,
  [ROUTE_NAMES.MSTEAMS_PRESENTING]: eventCategories.MS_TEAMS_APP,
  [ROUTE_NAMES.ZOOM_APP]: eventCategories.INTEGRATIONS,
  [ROUTE_NAMES.ZOOM_PRESENTATION_LIST]: eventCategories.PRESENTATION_LIST,
  [ROUTE_NAMES.ZOOM_AUDIENCE_APP]: eventCategories.PRESENTING_MODE,
  [ROUTE_NAMES.PRESENTATIONS]: eventCategories.PRESENTATION_LIST,
  [ROUTE_NAMES.SHARED_WITH_ME]: eventCategories.SHARE_WITH_ME,
  [ROUTE_NAMES.FOLDER_DETAIL]: eventCategories.PRESENTATION_LIST,
  [ROUTE_NAMES.SHARE_FOLDER_DETAIL]: eventCategories.SHARE_WITH_ME,
  [ROUTE_NAMES.TEAM_FOLDER_DETAIL]: eventCategories.MY_TEAM,
  [ROUTE_NAMES.TEMPLATE_LIBRARY]: eventCategories.TEMPLATE_LIBRARY,
  [ROUTE_NAMES.TEMPLATE_CATEGORY]: eventCategories.CATEGORY_PUBLIC_TEMPLATE_LISTING,
  [ROUTE_NAMES.TEAM]: eventCategories.MY_TEAM,
  [ROUTE_NAMES.TEAM_MEMBER]: eventCategories.MY_TEAM,
  [ROUTE_NAMES.USER_PROFILE]: eventCategories.MY_ACCOUNT,
  [ROUTE_NAMES.BILLING_LIST]: eventCategories.PAYMENT,
  [ROUTE_NAMES.BILLING_DETAIL]: eventCategories.PAYMENT,
  [ROUTE_NAMES.COMMUNITY]: eventCategories.INTEGRATIONS,
  [ROUTE_NAMES.UPGRADE]: eventCategories.UPGRADE_PLAN,
  [ROUTE_NAMES.USER_PLAN]: eventCategories.MY_PLAN,
  [ROUTE_NAMES.REDEEM]: eventCategories.MY_PLAN,
  [ROUTE_NAMES.SLIDE_TYPE_SHARE]: eventCategories.HOME,
  [ROUTE_NAMES.PRESENTATION_REPORT]: eventCategories.PRESENTATION_REPORT,
  [ROUTE_NAMES.MARKETPLACE]: eventCategories.MARKETPLACE,
  [ROUTE_NAMES.MARKETPLACE_DETAIL]: eventCategories.MARKETPLACE,
  [ROUTE_NAMES.INTEGRATION_CONNECT]: eventCategories.MARKETPLACE,
  [ROUTE_NAMES.WHITE_LABEL]: eventCategories.MARKETPLACE,
  [ROUTE_NAMES.REFERRAL]: eventCategories.REFER_FRIEND,
  [ROUTE_NAMES.DEMO_PRESENTATION]: eventCategories.CATEGORY_PUBLIC_TEMPLATE_DEMO_MODE,
  [ROUTE_NAMES.SSO]: eventCategories.PRESENTER_LOGIN,
  [ROUTE_NAMES.AUTH]: eventCategories.PRESENTER_LOGIN,
  [ROUTE_NAMES.GOOGLE_ONE_TAP_LANDING]: eventCategories.PRESENTER_REGISTER,
  [ROUTE_NAMES.LOGIN]: eventCategories.PRESENTER_LOGIN,
  [ROUTE_NAMES.OAUTH]: eventCategories.PRESENTER_LOGIN,
  [ROUTE_NAMES.DEVICE_GRANT]: eventCategories.PRESENTER_LOGIN,
  [ROUTE_NAMES.REGISTER]: eventCategories.PRESENTER_REGISTER,
  [ROUTE_NAMES.FORGOT_PASSWORD]: eventCategories.PRESENTER_FORGOTPASSWORD,
  [ROUTE_NAMES.VERIFY_EMAIL]: eventCategories.MY_ACCOUNT,
  [ROUTE_NAMES.TOKEN]: eventCategories.MY_ACCOUNT,
  [ROUTE_NAMES.ERROR_404]: eventCategories.HOME,
  [ROUTE_NAMES.CLEAR_TOKEN]: eventCategories.MY_ACCOUNT,
  [ROUTE_NAMES.PRESENTATION_DETAIL]: eventCategories.PRESENTATION_EDITOR,
  // Same component and same work as the editor above, so events raised there must land in the
  // same category rather than in whatever the default is for an unmapped route.
  [ROUTE_NAMES.PPT_ADDIN_EDIT_SLIDES]: eventCategories.PRESENTATION_EDITOR,
  [ROUTE_NAMES.PRESENTATION_DETAIL_PUBLIC]: eventCategories.PRESENTATION_EDITOR,
  [ROUTE_NAMES.PRESENTATION_BACKSTAGE]: eventCategories.PRESENTATION_BACKSTAGE,
  [ROUTE_NAMES.PRESENTATION_SHARE]: eventCategories.PRESENTING_MODE,
  [ROUTE_NAMES.PRESENTATION_SHARE_PRESENT]: eventCategories.PRESENT_EMBED,
  [ROUTE_NAMES.TEMPLATE_PREVIEW]: eventCategories.PRESENTATION_PREVIEW,
  [ROUTE_NAMES.PRESENTATION_PLAY_DEMO]: eventCategories.PRESENTING_MODE,
  [ROUTE_NAMES.SAVE_PRESENTATION]: eventCategories.PRESENTATION_EDITOR,
  [ROUTE_NAMES.GOOGLE_REDIRECT]: eventCategories.MY_ACCOUNT,
  [ROUTE_NAMES.GOOGLE_AUTH]: eventCategories.PRESENTER_LOGIN,
  [ROUTE_NAMES.ADMIN_ANALYTICS]: eventCategories.ADMIN_ANALYTICS,
}

export default {
  NO_CHAT_ROUTES,
  PUBLIC_ROUTES,
  OPEN_ROUTES_FOR_GUEST,
  DISALLOWED_ROUTES_FOR_SKOLETUBE,
}
